(() => {
  const normalise = text => text.trim().toLowerCase().replace(/\s+/g, ' ').replace(/^controls$/, 'control');
  function parseLines(lines) {
    const seen = new Map();
    return lines.flatMap(raw => {
      const text = raw.trim();
      if (!text) return [];
      const colon = text.indexOf(':');
      const label = colon < 0 ? text : text.slice(0, colon).trim();
      const value = colon < 0 ? text : text.slice(colon + 1).trim();
      if (!label || !value) return [];
      const base = normalise(label);
      const count = (seen.get(base) || 0) + 1;
      seen.set(base, count);
      return [{ key: count === 1 ? base : `${base} (${count})`, label, value }];
    });
  }
  function comparisonRows(products) {
    const rows = new Map();
    products.forEach((entries, column) => entries.forEach(entry => {
      if (!rows.has(entry.key)) rows.set(entry.key, { label: entry.label, values: products.map(() => '') });
      rows.get(entry.key).values[column] = entry.value;
    }));
    return [...rows.values()];
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseLines, comparisonRows };
    return;
  }
  const shell = document.querySelector('[data-mh-compare-shell]');
  if (!shell) return;
  const bar = shell.querySelector('[data-mh-bar]');
  const dialog = shell.querySelector('[data-mh-dialog]');
  const result = shell.querySelector('[data-mh-result]');
  const loading = shell.querySelector('[data-mh-loading]');
  const status = shell.querySelector('[data-mh-status]');
  const open = shell.querySelector('[data-mh-open]');
  const storageKey = 'mh-product-comparison-v1';
  let selected = [];
  let requestId = 0;
  const safeUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return null;
      return url.pathname;
    } catch { return null; }
  };
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) selected = [...new Set(saved.map(safeUrl).filter(Boolean))].slice(0, 4);
  } catch {}
  function sync() {
    document.querySelectorAll('[data-mh-select]').forEach(button => {
      const url = safeUrl(button.closest('[data-mh-product]').dataset.url);
      const active = selected.includes(url);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      const label = active ? shell.dataset.selected : shell.dataset.select;
      if (button.textContent !== label) button.textContent = label;
    });
    bar.hidden = selected.length === 0;
    shell.querySelector('[data-mh-count]').textContent = `${selected.length} / 4`;
    open.disabled = selected.length < 2;
    try { sessionStorage.setItem(storageKey, JSON.stringify(selected)); } catch {}
  }
  const element = (tag, text) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    return node;
  };
  async function showComparison() {
    if (selected.length < 2) return;
    const current = ++requestId;
    const urls = [...selected];
    result.replaceChildren();
    loading.hidden = false;
    if (!dialog.open) dialog.showModal();
    try {
      const products = await Promise.all(urls.map(async path => {
        const url = new URL(path, location.origin);
        url.searchParams.set('view', 'mh-specs');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Product unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const product = html.querySelector('[data-mh-product]');
        if (!product) throw new Error('Parameters unavailable');
        return { url: path, title: product.dataset.title, price: html.querySelector('[data-mh-compare-price]')?.textContent.trim() || '', entries: parseLines([...product.querySelectorAll('[data-mh-spec-row]')].map(row => row.textContent)) };
      }));
      if (current !== requestId || !dialog.open) return;
      const table = element('table');
      table.style.minWidth = `${150 + products.length * 210}px`;
      const head = element('thead');
      const header = element('tr');
      const corner = element('th', shell.dataset.parameter);
      corner.scope = 'col';
      header.append(corner);
      products.forEach(product => {
        const th = element('th');
        th.scope = 'col';
        const link = element('a', product.title);
        link.href = product.url;
        const remove = element('button', shell.dataset.remove);
        remove.type = 'button';
        remove.setAttribute('aria-label', `${shell.dataset.remove}: ${product.title}`);
        remove.addEventListener('click', () => {
          selected = selected.filter(url => url !== product.url);
          sync();
          if (selected.length < 2) dialog.close(); else showComparison();
        });
        th.append(link);
        if (product.price) {
          const price = element('div', product.price);
          price.className = 'mh-compare-price';
          th.append(price);
        }
        th.append(remove);
        header.append(th);
      });
      head.append(header);
      const body = element('tbody');
      comparisonRows(products.map(product => product.entries)).forEach(row => {
        const tr = element('tr');
        const label = element('th', row.label);
        label.scope = 'row';
        tr.append(label);
        row.values.forEach(value => tr.append(element('td', value || shell.dataset.missing)));
        body.append(tr);
      });
      if (!body.childElementCount) result.append(element('p', shell.dataset.empty));
      table.append(head, body);
      result.append(table);
    } catch {
      if (current === requestId && dialog.open) result.append(element('p', shell.dataset.error));
    } finally {
      if (current === requestId) loading.hidden = true;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mh-select]');
    if (!button) return;
    const url = safeUrl(button.closest('[data-mh-product]').dataset.url);
    if (!url) return;
    status.textContent = '';
    if (selected.includes(url)) selected = selected.filter(item => item !== url);
    else if (selected.length < 4) selected.push(url);
    else status.textContent = shell.dataset.limit;
    sync();
  });
  open.addEventListener('click', showComparison);
  shell.querySelector('[data-mh-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { requestId++; loading.hidden = true; });
  shell.querySelector('[data-mh-clear]').addEventListener('click', () => {
    selected = [];
    status.textContent = '';
    sync();
  });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-mh-product]') || node.querySelector('[data-mh-product]'))))) sync();
  }).observe(document.body, { childList: true, subtree: true });
  sync();
})();
